import React, { Component } from "react";
import { Field } from "formik";
import CheckField from "../fields/CheckField";
import { injectIntl } from "react-intl";

class FieldsBasketballGoals extends Component {
  render() {
    const { intl } = this.props;
    return (
      <>
        <Field
          name="basketballTwo"
          component={CheckField}
          label={intl.formatMessage({
            id: "basketball.basketgoals",
            defaultMessage: "Bramkokosze",
          })}
        />
      </>
    );
  }
}

export default injectIntl(FieldsBasketballGoals);
